import { CartContext } from '../../../features/cartContext/CartContext'
import { useContext } from 'react'

import { AllProducts } from "../../../constants"

import { moments } from '../../../constants'
import { Link, useNavigate } from 'react-router-dom'



const ShoppingCard = (props) => {

    const navigate = useNavigate()

    const cart = useContext(CartContext)

    const { fPicName, urls, fPrice, text, title, salesTax, bestSeller, _id,openDetails, setOpenDetails } = props

    const content_mod_tailwind = (
        <div className="relative flex flex-col my-2 lg:my-6 bg-red-400 shadow-sm border border-slate-200 rounded-sm w-full ">
            <div className="block items-center">
                <img
                    className='w-full h-20 object-cover'
                    src={`${urls ? urls[0] : fPicName}`}
                    alt=''
                />
            </div>
            <p className="block text-slate-600 leading-normal text-[12px] text-start font-light mb-2 truncate">
                {text}
                {/* Because it&apos;s about motivating the doers. Because I&apos;m here to follow my dreams and inspire others. */}
            </p>

            {fPrice === "0.00" ?
                <>

                    <div className='text-center align-middle' >

                        <p className="cursor-pointer text-slate-800 text-xs hover:underline flex items-center">
                            Out of  Stack Contact us to check  availability
                        </p>

                    </div>

                </>
                : <>

                    <h1 class="flex justify-left gap-1 mt-1 font-bold text-gray-600 text-sm">
                        <span class="text-sm">$</span>{fPrice}
                    </h1>
                    <div onClick={() => cart.addOneToCart(props)} className='text-center align-middle' >

                        <p className="cursor-pointer text-slate-800 font-semibold text-sm hover:underline flex items-center">
                            Add to Cart
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                            </svg>
                        </p>
                    </div>
                </>
            }
        </div>
    )
    const contentMod=(
       <div class="flex flex-col items-center justify-center mt-32">
    {/* <!-- Product Card --> */}
    <div class="flex flex-col shadow-md cursor-pointer w-96 hover:-translate-y-1 duration-300">
        {/* <!-- Preview --> */}
        <div class="inline relative group h-48">
            {/* <!-- Thumbnail --> */}
            <img class="absolute rounded-t object-cover h-full w-full"
               src={`${urls ? urls[0] : fPicName}`}
                alt="Product Preview" />

                {/* <!-- Hover Bar --> */}
                <div class="flex flex-row absolute justify-end
                    h-16 w-full bottom-0 px-3 space-x-2
                    bg-none opacity-0 group-hover:opacity-100
                    group-hover:bg-gradient-to-t from-black/20 via-gray-800/20 to-transparent 
                    transition-all ease-in-out duration-200 delay-100">

                    {/* <!-- Add to Bookmarks Button --> */}
                    <button class="bg-gray-50/10 rounded-full 
                        px-1 h-9 w-9 my-auto hover:bg-gray-50/20
                        transition-colors duration-200">
                        <i class="mdi mdi-playlist-plus text-xl text-gray-200
                            hover:text-white transition-all duration-200"
                            title="Add to Bookmarks"></i>
                    </button>

                    {/* <!-- Add to Favorites Button --> */}
                    <button class="bg-gray-50/10 rounded-full 
                        px-1 h-9 w-9 my-auto hover:bg-gray-50/20
                        transition-colors duration-200">
                        <i class="mdi mdi-heart text-xl text-gray-200 p-1
                            hover:text-white transition-all duration-200"
                            title="Add to Favorites"></i>
                    </button>
                </div>
        </div>

        {/* <!-- Body --> */}
        <div class="flex flex-col bg-white rounded-b p-3">
            {/* <!-- Title --> */}
            <div class="text-sm font-semibold text-gray-900 hover:underline truncate">
                Awesome Fantastic Super Uber Harika Merveilleux Pro Ultra Max Plus Plus Makeup Stuff
            </div>

            {/* <!-- Author - Category --> */}
            <div class="text-xxs text-gray-400 truncate mt-1">
                by

                {/* <!-- Author --> */}
                <a class="font-semibold hover:underline"> EgoistDeveloper </a>

                in
                {/* <!-- Category --> */}
                <a class="font-semibold hover:underline"> e-commerce </a>
            </div>

            {/* <!-- Price --> */}
            <div class="text-sm text-gray-600 font-bold mt-4 mb-1">
                $23
            </div>

            {/* <!-- Body --> */}
            <div class="flex flex-row mt-2">
                {/* <!-- Detail Column --> */}
                <div class="flex flex-col flex-auto">
                    {/* <!-- Rating --> */}
                    <div class="flex flex-row group">
                        <i class="mdi mdi-star text-xs text-amber-400 
                            hover:text-amber-500 transition-all duration-200"
                            title="Worst"></i>

                        <i class="mdi mdi-star text-xs text-amber-400 
                            hover:text-amber-500 transition-all duration-200"
                            title="Bad"></i>

                        <i class="mdi mdi-star text-xs text-amber-400 
                            hover:text-amber-500 transition-all duration-200"
                            title="Not Bad"></i>

                        <i class="mdi mdi-star text-xs text-amber-400 
                            hover:text-amber-500 transition-all duration-200" 
                            title="Good"></i>

                        <i class="mdi mdi-star text-xs text-amber-400 
                            hover:text-amber-500 transition-all duration-200"
                            title="Awesome"></i>

                        <div class="text-xxs text-gray-400 ml-1 hover:underline">
                            (45)
                        </div>
                    </div>

                    {/* <!-- Statistic --> */}
                    <div class="text-xxs text-gray-400 mt-1" title="34k Downlaods in this year">
                        34k Downloads
                    </div>
                </div>

                {/* <!-- Button Column --> */}
                <div class="flex flex-row flex-auto justify-end">
                    {/* <!-- Cart Button --> */}
                    <a class="flex text-xs border px-3 my-auto py-2 mr-2
                        border-amber-500 group hover:bg-amber-500 
                        rounded-xss
                        transition-all duration-200">
                        
                        {/* <!-- Icon --> */}
                        <i class="mdi mdi-cart-outline text-amber-700
                            group-hover:text-white delay-100"></i>
                    </a>

                    {/* <!-- Preview Link Button --> */}
                    <a class="flex text-xs border px-3 my-auto py-2 
                        border-amber-500 group hover:bg-amber-500 
                        rounded-xss
                        transition-all duration-200">
                        
                        {/* <!-- Icon --> */}
                        <i class="mdi mdi-eye-outline text-amber-700
                            group-hover:text-white delay-100"></i>

                        {/* <!-- Text --> */}
                        <div class="text-xxs text-amber-700 font-semibold ml-2
                            group-hover:text-white delay-100">
                            Live Preview
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    </div>

    )
    const contents=(

        <div className='bg-white rounded flex flex-col overflow-hidden shadow-md h-64'>
            <div>
                <img src={`${urls ? urls[0] : fPicName}`} className=' size-24 md:size-28 object-cover'/>
            </div>
            <div className='flex flex-col items-center md:items-start'>
                <span className='text-xs h-6 font-bold'>{title} </span>                
                <span className='text-xs h-6 text-center'>{text}</span>
                <span className='block text-center text-gray-400 text-sm'>
                    
               {fPrice === "0.00" ?
                <>
                    <div className=' text-center h-24' >

                        <p className="cursor-pointer text-slate-800 text-xs hover:underline flex items-center">
                            Out of  Stack
                        </p>

                    </div>

                </>
                : < div className='text-center block h-24'>

                    <h1 class="flex  gap-1 mt-1 font-bold text-gray-600 text-sm">
                        <span class="text-sm text-center">${fPrice}</span>
                    </h1>
                    <div onClick={() => cart.addOneToCart(props)} className='text-center align-middle' >
                        <p className="cursor-pointer text-slate-800 font-semibold text-sm hover:underline flex items-center">
                            <span class="text-xxs flex text-red-700 font-semibold ml-2 group-hover:text-slate-600 delay-100">
                            Add to Cart
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                            </svg>
                            </span>
                        </p>
                    </div>
                </div>
            }
 
                </span>
            </div>
        </div>   
    )
    const newContent=(
       
  <div class="w-60 p-2 bg-white rounded-xs transform transition-all hover:-translate-y-2 duration-300 shadow-lg hover:shadow-xl">
    {/* <!-- Image --> */}
    <img class="h-40 w-full object-cover rounded-xs" src={`${urls ? urls[0] : fPicName}`} alt=""/>
    <div class="p-2">
    {/* <!-- Heading --> */}
    <h2 class="font-bold text-lg mb-2 ">{title}</h2>
    {/* <!-- Description --> */}
    <p class="text-sm text-gray-600">{text}</p>
    </div>
    {/* <!-- CTA --> */}
    <div class="m-2">
    <a role='button' href='#' class="text-white bg-purple-600 px-3 py-1 rounded-md hover:bg-purple-700">Learn More</a>
    </div>
  </div>
    )
    const newContentNew=(
       <div class="min-h-full bg-white flex items-center justify-center">
            <div class="max-w-sm w-full h-full bg-white rounded-sm shadow-lg overflow-hidden hover:shadow-xl transition-all">
                <div class="relative">
                <img 
                    src={`${urls ? urls[0] : fPicName}`}
                    alt="Product"
                    class="w-full h-32 object-cover overflow-hidden"
                />
                {/* <span class="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Sale
                </span> */}
                </div>
                
                <div class="p-1 space-y-2">
                <div>
                    <h3 class="text-sm font-semibold text-gray-900 line-clamp-1 hover:line-clamp-2 cursor-pointer">{title}</h3>
                    <p class="text-gray-500 mt-1 line-clamp-1 text-sm hover:line-clamp-3 hover:cursor-pointer">{text}</p>
                </div>                
                <div class="flex justify-between items-center">
                    <div class="space-y-1">
                        <p class={`text-md font-bold text-gray-900 ${fPrice==="0.00"? "line-through":""}`}>${fPrice}</p>
                    {/* <p class="text-sm text-gray-500 line-through">$69.99</p> */}
                    </div>
                    {/*                     
                    <div class="flex items-center gap-1">
                    <div class="text-yellow-400">★★★★</div>
                    <div class="text-gray-300">★</div>
                    <span class="text-sm text-gray-600 ml-1">(42)</span>
                    </div> */}
                </div>

                {fPrice != "0.00" ?
                <button
                    onClick={() => cart.addOneToCart(props)} 
                    class="w-full bg-red-100 hover:text-white border border-spacing-1 border-gray-500 hover:bg-indigo-500 text-gray-900 font-medium py-1 flex text-center text-sm justify-center items-center rounded-sm transition-colors">
                    <span>Add to Cart</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                    </svg>
                </button>:
                    <p className="cursor-pointer text-slate-800 text-xs hover:underline flex items-center">
                        Out of  Stack
                    </p>
                    }
                </div>
            </div>
        </div>
    ) 
    const ContentCard=(
        <div class="order-3 border border-default-200 rounded-lg p-4 overflow-hidden hover:border-primary hover:shadow-xl transition-all duration-300">
            <div class="relative rounded-lg overflow-hidden divide-y divide-default-200 group space-y-2">
                <div class="mb-4 mx-auto">
                    <img 
                    // class="w-full h-full group-hover:scale-105 transition-all" 
                        src={`${urls ? urls[0] : fPicName}`} alt="Product"
                        class="w-full h-32 object-cover overflow-hidden group-hover:scale-105 transition-all"
                    />
                </div>

                <div class="pt-2">
                    <div class="flex items-center justify-between mb-4">
                        <h1 onClick={()=>{setOpenDetails(true)}} class="text-default-800 text-sm lg:text-xl font-semibold line-clamp-1 after:absolute after:inset-0">{title}</h1>
                        
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="heart" class="lucide lucide-heart h-6 w-6 text-default-200 cursor-pointer hover:text-red-500 hover:fill-red-500 transition-all relative z-10"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path></svg> */}
                    </div>
                    <div>
                        <p class="text-gray-500 mt-1 line-clamp-1 text-xs md:text-sm hover:line-clamp-3 hover:cursor-pointer">{text}</p>
                    </div>

                    {/* <span class="inline-flex items-center gap-2 mb-4">
                        <span class="bg-primary rounded-full p-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="star" class="lucide lucide-star h-3 w-3 text-white fill-white"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg></span>
                        <span class="text-sm text-default-950 from-inherit">4.2</span>
                    </span> */}

                    <div class="flex items-end justify-between mb-4">
                        <h4 class={`font-semibold text-sm lg:text-xl text-default-900 ${fPrice==="0.00"? "line-through":""}`}>${fPrice}</h4>                                    
                    </div>
                    <a class="relative z-10 w-full inline-flex items-center justify-center rounded-sm border text-xs border-primary bg-primary px-3 py-1 md:px-6 md:py-3 text-center md:text-sm font-medium text-white shadow-sm transition-all duration-500 hover:bg-primary-500" href="cart.html">Add
                        to cart
                    </a>
                    {/* <!-- end btn --> */}
                </div>
            </div>
        </div>  
    )


    const contentCardMd=(
        <div className="mx-auto transition-all duration-300">
            <div className="relative my-4 w-40 h-[280px] mx-auto " key={title}>
                <div className="absolute h-full -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25"></div>

                <div className="relative px-2 py-3 h-full bg-white ring-1 ring-gray-900/5 rounded-lg leading-none flex items-top justify-start space-x-6">

                    <div className="space-y-2 relative flex flex-col ">

                        <img
                            className="w-full h-32 object-cover object-center"
                            src={`${urls ? urls[0] : fPicName}`} alt="Product"
                            
                        />
                        <span className='flex flex-col justify-between'>
                            <span onClick={()=>{setOpenDetails(true)}} className=' cursor-pointer'  >

                                <div className='mb-3 text-sm font-extrabold tracking-tight text-gray-900 dark:text-white'>
                                    {/* <svg className="w-8 h-8 text-purple-600" fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6.75 6.75C6.75 5.64543 7.64543 4.75 8.75 4.75H15.25C16.3546 4.75 17.25 5.64543 17.25 6.75V19.25L12 14.75L6.75 19.25V6.75Z"></path>
                                    </svg> */}
                                    <p className=' overflow-hidden text-xs truncate'>{title}</p>
                                </div>
                            
                                <p className=" text-gray-500 dark:text-gray-400 text-xs line-clamp-3">
                                    {text}
                                </p>
                            </span>
                            
                            <span class=" mt-auto">
                                {/* <a onClick={()=>{setOpenDetails(true)}}  className="block text-xs text-indigo-400 group-hover:text-slate-800 transition duration-200">Read Details →</a> */}
                            
                                <a class="absolute bottom-0 left-0 right-0 dark:text-white text-xs rounded-md cursor-pointer border-primary bg-primary  text-center md:text-sm font-medium text-white shadow-sm transition-all duration-500 hover:bg-primary-500 align-baseline">
                                    Add to cart
                                </a>
                            </span>
                        </span>
                       
                        {/* <div className=' bg-secondary-100 text-secondary-200 text-xs font-bold rounded-full p-2 absolute top-0 ml-2 mt-2'>
                            <span>time to cook</span>
                        </div> */}
                    </div>

                </div>
            </div>
        </div>
    )
    

    return contentCardMd 
}


export default ShoppingCard
